import React from "react";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, getWindowDimensions, ByteLength, isEnabled} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import EntryInput from "../components/EntryInput";
import Tooltip from '@material-ui/core/Tooltip';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Paper from '@material-ui/core/Paper';
import { imageopen, setimagelist } from '../modules/imagedlgstore';
import noimage from '../Resources/noimage.jpg';

function entryBaseLabelFontsize(name) {
    //項目名が16バイト以上の場合フォントを小さくする　ver1.6
    return ByteLength(name) > 16 ? '9px' : 'none';
}

function resolveEntryBaseWidth(windowWidth, showimage, widthValue) {
    var w = 0;
    var ratio = 1.33;
    if (windowWidth <= 600) {
        w = 100;
    } else if (windowWidth <= 800) {
        let size = [50, 50, 100, 100, 50, 60, 60, 60, 80];
        w = size[widthValue];
        ratio = 2;
    } else if (windowWidth <= 1000) {
        let size = [50, 50, 100, 100, 25, 40, 40, 60, 80];
        ratio = 2;
        w = size[widthValue];
    } else if (windowWidth <= 1500) {
        let size = [25, 50, 75, 100, 25, 20, 40, 60, 80];
        w = size[widthValue];
    } else {
        let size = [25, 50, 75, 100, 12.5, 20, 40, 60, 80];
        w = size[widthValue];
    }
    if (showimage) w *= ratio;
    if (w > 100) w = 100;
    return w.toString() + "%";
}

function EntryBaseWarnTip(param) {
    return (
        <Tooltip title={param.msg}>
            <div style={{ position: 'absolute', top: -2, left: -2, cursor: 'pointer' }}>
                {param.conv ? <span className="material-icons convert">check_circle</span> : <span className="material-icons warning">announcement</span>}
            </div>
        </Tooltip>
    );
}

// Sortable系コンポーネントはコンポーネント外で一度だけ生成する。
// (コンポーネント内で生成すると毎レンダーで別のコンポーネント型になり、
//  全入力欄がアンマウント→再マウントされてフォーカス喪失・入力欠落の原因になる)
const EntryBaseSortableItem = SortableElement(({ value, itemProps }) => (
    <div style={{ boxSizing: 'border-box', width: resolveEntryBaseWidth(itemProps.windowWidth, itemProps.showimage, value.width), border: 'solid 1px #ccc' }}>
        <div className='fieldlabel' style={{ cursor: 'context-menu', backgroundColor: itemProps.themestyle.header.back, color: itemProps.themestyle.header.color, userSelect: 'none', fontSize: entryBaseLabelFontsize(value.columnnm) }}>
            {value.columnnm}
        </div>
        <div className={'fieldinput'} style={{ position: 'relative', backgroundColor: value.locked || ((value.primary || value.unchange) && itemProps.formstatus === 'ENTRY FORM') ? '#eee' : (value.required ? itemProps.themestyle.body.require : 'inset') }}>
            <EntryInput
                def={value}
                dataRef={itemProps.entrydataRef}
                textfields={itemProps.textfields}
                fnc={itemProps.fnc}
                changewidth={itemProps.changeWidth}
                ValueChanged={itemProps.valueChanged}
                ValueChangeing={itemProps.valueChangeing}
            />
            {isEmpty(itemProps.warningMessage(value)) ? null : <EntryBaseWarnTip msg={itemProps.warningMessage(value)} conv={false} />}
        </div >
    </div>
));

const EntryBaseSortableList = SortableContainer(({ items, itemProps }) => {
    return (
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left' }}>
            {items.map((value, index) => (
                <EntryBaseSortableItem
                    key={`${value.columnid}_${value.type}`}
                    index={index}
                    value={value}
                    itemProps={itemProps}
                    disabled={itemProps.layoutlock}
                />
            ))}
        </div>
    );
});

export default function EntryBase(props) {

    const images = useSelector(state => state.imgdlg.images);
    const formstatus = useSelector(state => state.form.status);
    const themestyle = useSelector(state => state.form.themestyle);
    const warndescription = useSelector(state => state.form.warndiscription);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [imgsrc, setimgsrc] = useState('');
    const [imgindex, setimgindex] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (formstatus.indexOf("FORM") !== -1) {
            setTimeout(() => {
                //先頭項目にフォーカスをあてる
                var key = Firstcolumn();
                if (!isEmpty(key)) {
                    try {
                        document.getElementById(key)?.focus();
                        document.getElementById(key)?.select();
                    } catch (error) {
                        console.log(error);
                    }
                }
            }, 500);
        }
    }, [formstatus]);

    useEffect(() => {
        if (isEmpty(images)) {
            setimgsrc(noimage); return;
        }
        if (images.length === 0) {
            setimgsrc(noimage); return;
        }
        setimgsrc(images[0].imageurl);
        setimgindex(0);
    }, [images]);

    //画像変更
    function imageChange(index) {
        setimgsrc(images[index].imageurl);
        setimgindex(index);
    }
    function ImageDialog() {
        if (isEmpty(images)) return;
        if (images.length === 0) return;
        dispatch(imageopen({ images: images, default: images[imgindex].filename }));
    }

    //先頭項目を取得
    function Firstcolumn() {
        if (isEmpty(props.textfields)) return "";
        if (props.textfields.length === 0) return "";
        return props.textfields[0].columnid + "_" + props.textfields[0].type;
    }
    function ChangeWidth(def, deltaY) {
        let col = props.textfields.find(e => e.columnid === def.columnid && e.type === def.type);
        if (isEmpty(col)) return;
        if (deltaY > 0) {   //-
            if (col.width === 0) return;
            col.width -= 1;
        } else {            //+
            if (col.width === 3) return;
            col.width += 1;
        }
        props.settextfields({ ...props.textfields });
    }
    function warningMessage(def) {
        if (warndescription.length === 0) return "";
        const warn = warndescription.find(e => e.rowid === "0" && e.col === def.columnid);
        if (isEmpty(warn)) return "";
        return warn.message;
    }

    //基本項目入れ替え
    const onSortEnd = ({ oldIndex, newIndex }, e) => {
        let type = e.target.parentNode.id.replace('basepanel', '');
        let idx = 0;
        for (let i = 0; i < props.textfields.length; i++) {
            if (props.textfields[i].type === type) {
                idx = i; break;
            }
        };
        props.settextfields(arrayMove(props.textfields, oldIndex + idx, newIndex + idx));
    };
    function shouldCancelStart(e) {
        //Label以外ソート不可
        if (e.target.className !== 'fieldlabel') return true;
    }

    //Sortable系へ渡す表示・操作用の依存一式
    const itemProps = {
        windowWidth: windowDimensions.width,
        showimage: props.showimage,
        themestyle: themestyle,
        formstatus: formstatus,
        entrydataRef: props.entrydataRef,
        textfields: props.textfields,
        fnc: props.fnc,
        changeWidth: ChangeWidth,
        valueChanged: props.ValueChanged,
        valueChangeing: props.ValueChangeing,
        layoutlock: props.layoutlock,
        warningMessage: warningMessage
    };

    return (
        isEnabled(props.showimage) ?
            <div style={{ display: 'grid', gridTemplateColumns: windowDimensions.width <= 1000 ? '1fr 1fr' : '1fr 3fr' }}>
                <div style={{ paddingRight: 5, gridRow: '1/3' }}>
                    <Paper
                        style={{
                            width: '100%',
                            height: 'auto',
                            padding: 10,
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <img src={imgsrc}
                            style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover' }}
                            onDoubleClick={ImageDialog}
                            draggable={false}
                        />
                    </Paper>
                </div>
                <div>
                    < EntryBaseSortableList
                        axis = { "xy"}
                        items = { props.textfields.filter(e => e.type === props.panel.type) }
                        itemProps = { itemProps }
                        onSortEnd = { onSortEnd }
                        distance = { 1}
                        shouldCancelStart = { shouldCancelStart }
                    />
                </div>
                {images.length > 1 ?
                    <div style={{ alignSelf: 'end' }}>
                        {images.map((value, index) => (
                            <img src={value.imageurl}
                                style={{ width: 70, height: 70, objectFit: 'cover', border: imgindex === index ? '3px solid #4fbce4' :'1px solid #ccc', margin: 3, cursor: 'pointer' }}
                                onClick={() => imageChange(index)}
                                draggable={false}
                                />
                        ))}
                    </div>
                : null}
            </div>
        :
        <EntryBaseSortableList
            axis={"xy"}
            items={props.textfields.filter(e => e.type === props.panel.type)}
            itemProps={itemProps}
            onSortEnd={onSortEnd}
            distance={1}
            shouldCancelStart={shouldCancelStart}
        />
    );
}
